export default "__VITE_ASSET__CGNM$9CM__"